// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2R9kS","col":"styles_col__2zf79"};